import Stylus from './Stylus';
import CommentDrawingBrush from './CommentDrawingBrush';

class StylusComment extends Stylus {
  constructor({ controller }) {
    super({ controller });
  }

  activate() {
    const brush = new CommentDrawingBrush(this.controller.canvas, this);
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  iconClass() {
    return 'fa-regular fa-comment';
  }

  description() {
    return 'Comment';
  }

  cursor() {
    return 'crosshair';
  }
}

export default StylusComment;
